// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"%235b6b86\"><path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NorstellaCoverageFinder styles */

/* ===== BASE LAYOUT STYLES ===== */
.norstella-pf-container {
  display: flex;
  font-family: Arial, sans-serif;
  flex-direction: row;
  height: inherit;
}

.norstella-pf-main-wrapper {
  background-color: white;
  border-radius: 10px; 
  padding: 5px;
}

.norstella-pf-channelCardPageContainer {
  display: flex;
  flex-direction: row;
  height: inherit;
}

/* ===== LEFT AND RIGHT PANELS ===== */
.norstella-pf-right {
  background-color: #d4dceb;
  padding: 20px 40px;
  overflow-y: auto;
  display: flex;
  order: 2;
  flex-direction: column;
  border-radius: 15px;
}

/* ===== HEADER STYLES ===== */
.norstella-pf-header {
  color: #0a1f3d;
  font-weight: bold;
  font-size: 28px;
  white-space: initial;
  margin-bottom: 10px;
  text-align: center;
}

.norstella-pf-nav-header {
  color: #0a1f3d;
  font-weight: bold;
  font-size: 28px;
  line-height: 1;
  text-align: center;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  text-decoration: underline;
}

.norstella-pf-headerSubHeader {
  font-weight: bold;
  white-space: initial;
  margin-bottom: 20px;
  text-align: center;
}

.norstella-pf-headerSubHeader span {
  font-size: 14px;
}

/* ===== CHANNEL STYLES ===== */
.norstella-pf-channels {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 600px;
}

.norstella-pf-channel {
  background-color: #1e5c79;
  color: white;
  padding: 12px 16px;
  text-align: center;
  min-width: 160px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 20px;
  box-shadow: 5px 4px 8px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: transform 0.2s;
  min-width: 250px;
}

.norstella-pf-channel:hover {
  transform: scale(1.03);
  background-color: #1e5c79c2;
}

.norstella-pf-grid-wrapper {
  display: flex;
}

.norstella-pf-grid-channel {
  display: grid;
  gap: 2.5rem 5rem;
  max-width: 800px;
}

.norstella-pf-grid-channel .norstella-pf-channel:last-child {
  grid-column: span 2;
  justify-self: center;
  width: 160px;
  min-width: 160px;
}

.norstella-pf-footer {
  font-size: 12px;
  color: #333;
  line-height: 1.5;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.norstella-pf-footer strong {
  font-weight: bold;
}

/* ===== IFRAME STYLES ===== */
.norstella-pf-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.norstella-pf-externalhtml-container {
  width: 100%;
  height: 100%;
}

/* ===== CHANNEL HTML CARD PAGE STYLES (CHCP) ===== */

.norstella-pf-htmlCardPage-container {
  display: grid;
  grid-template-areas:
    "nav-left nav-center nav-right"
    "content content content"
    "footer footer footer";
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 1fr auto 1fr;
  font-family: Arial, sans-serif;
  background-color: #d4dceb;
  padding: 15px 20px 0 20px;
  gap: 0;
  overflow: auto;
  border-radius: 15px;
  flex-grow: 1;
}

/* Grid Navigation Areas */
.norstella-pf-nav-left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.norstella-pf-nav-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* ===== NAVIGATION BUTTONS ===== */
.norstella-pf-back-btn,
.norstella-pf-forward-btn,
.norstella-pf-changeSelectedResult-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 5px;
  border: none;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  outline: none;
  background: transparent;
}

.norstella-pf-back-btn-icon,
.norstella-pf-forward-btn-icon,
.norstella-pf-changeSelectedResult-btn-icon {
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  width: 24px;
  height: 24px;
  overflow: hidden;
}

.norstella-pf-back-btn-label,
.norstella-pf-forward-btn-label,
.norstella-pf-changeSelectedResult-btn-label {
  text-transform: capitalize;
  font-weight: bold;
  color: #000000;
  text-decoration: underline;
}


/* ===== HEADER SECTION ===== */
.norstella-pf-header-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ===== CONTENT SECTION ===== */
.norstella-pf-content-section {
  grid-area: content;
  overflow: hidden;
  justify-self: center;
  padding-top: 20px;
}

/* ===== FOOTER SECTION ===== */
.norstella-pf-footer-section {
  grid-area: footer;
  padding: 20px 20px;
}

/* ===== CHANNEL SEARCH PAGE (CSP) ===== */
.norstella-pf-channelSearchPage-main-container {
  display: flex;
  flex-direction: row;
  height: inherit;
}

.norstella-pf-channelSearchPage-container {
  display: grid;
  grid-template-areas:
    "nav"
    "changeResult"
    "search"
    "plan"
    "post"
    "footer";
  grid-template-rows: auto auto auto auto 1fr auto;
  grid-template-columns: 1fr;
  font-family: Arial, sans-serif;
  background-color: #d4dceb;
  padding: 15px 20px 0 20px;
  gap: 0;
  overflow: auto;
  border-radius: 15px;
  flex-grow: 1;
}

/* ===== ROW WRAPPERS ===== */
.norstella-pf-row { 
  width: 100%; 
}

.norstella-pf-row-nav { 
  grid-area: nav; 
  display: grid; 
  grid-template-columns: 25% 50% 25%; 
  align-items: center;   
}


.norstella-pf-row-search { 
  grid-area: search;
  display: grid;
  grid-template-columns: 54% 46%;
  margin-left: 10px;  
}

.norstella-pf-row-plan { 
  grid-area: plan; 
}

.norstella-pf-row-post { 
  grid-area: post; 
}

.norstella-pf-row-footer { 
  grid-area: footer; 
}

/* ===== SEARCH COMPONENTS ===== */
.norstella-pf-search-row {
  grid-area: search;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  padding: 0 0 6px 0;
  margin-top: 12px;
}

																			   
.norstella-pf-subheader-wrap {
  grid-area: subheader;
  min-width: 0;
  overflow: hidden;
}

								   
.norstella-pf-location-controls { 
  display: block;
  position: relative;
}

.norstella-pf-search-label,
.norstella-pf-plan-label { 
  font-family: Arial, sans-serif;
  font-size: 13px; 
  display: block;
  color: #22346A;
  padding-bottom: 2px;
}

.norstella-pf-location-input-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.norstella-pf-input-group {
  display: inline-flex;
  align-items: center;
  background: #ffffff;
  border-radius: 7px;
  border: 1px solid #666;
  height: 38px;
  position: relative;
}

/* Error state styling for input group */
.norstella-pf-input-group.norstella-pf-error-state {
  border: 2px solid red;
  box-shadow: 0 0 0 1px red;
}

.norstella-pf-input-with-icon { 
  position: relative; 
}

.norstella-pf-input-with-icon .norstella-pf-input { 
  padding-left: 28px; 
}

.norstella-pf-input-icon {
  position: absolute;
  left: 8px;
  width: 16px;
  height: 16px;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / contain;
  background-color: #5b6b86;
}

.norstella-pf-input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 250px;
  display: flex;
  align-items: center;
}

.norstella-pf-clear-btn {
  border: none;
  background: transparent;
  color: #5b6b86;
  font-size: 18px;
  cursor: pointer;
  padding: 0 4px;
}

.norstella-pf-primary-btn {
  background: #0a1f3d;
  color: #ffffff;
  border-radius: 7px;
  font-weight: 700;
  cursor: pointer;  
  margin-top: 16px;
  width: 100px;
  font-size: 16px;
  height: 38px;
}

.norstella-pf-primary-btn:disabled { 
  opacity: 0.5;
  cursor: unset;
}

/* ===== ERROR MESSAGE ===== */
.norstella-pf-error-message { 
  color: red;
  font-size: 13px;
  font-weight: bold;
  margin-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1;
}

.norstella-pf-no-plan-details {
  color: red;
}

/* ===== PLAN SEARCH ===== */
.norstella-pf-plan-search-row {
  grid-area: plan;
  width: 100%;
  margin-left: 10px;
}

.norstella-pf-plan-input-group { 
  width: 100%; 
  height: 38px;   
  margin-bottom: 20px;
}


/* ===== DISABLED AND HIGHLIGHT Location & Plan input ===== */
.norstella-pf-disabled {
  opacity: 0.6;
}

/* Highlight for plan search only (not for geo location input) */
.norstella-pf-highlight-search {
  border: 1px solid #000000;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
  animation: pulse-border 1s ease-in-out;
}

@keyframes pulse-border {
  0% { border-color: #000000; }
  50% { border-color: #333333; }
  100% { border-color: #000000; }
}

/* ===== SUBHEADER STYLES ===== */
												 
.norstella-pf-subheader, .norstella-pf-nav-subheader { 
  white-space: normal; 
  text-overflow: unset; 
  overflow: hidden; 
  color: rgb(10, 31, 61);
}

.norstella-pf-geo {
  display: flex;
  gap: 10px;
  margin-right: 10px;
  justify-content: flex-end;
  align-items: center;
}

/* Geo Location Container for Post Search */
.norstella-pf-geo-post-search {
  flex-direction: column;
  align-items: flex-end;
  gap: 0px;
}

/* Change Selected Result Button */
.norstella-pf-nav-changeSelectedResult {
  display: flex;
  justify-content: flex-end;
}

/* Change Selected Result Button - Top Position (when hideLocation is true) */
.norstella-pf-nav-changeSelectedResult-top {
  display: flex;
  justify-content: flex-end; 
  grid-area: changeResult; 
}

/* ===== MUI AUTOCOMPLETE STYLES (CONSOLIDATED) ===== */
.norstella-pf-MuiAutocomplete-root {
  width: 100%;
}

/* Ensure autocomplete dropdown connects seamlessly with input */
.norstella-pf-geo-autocomplete,
.norstella-pf-plan-search-input {
  position: relative;
}

.norstella-pf-geo-autocomplete .norstella-pf-MuiAutocomplete-popper,
.norstella-pf-plan-search-input .norstella-pf-MuiAutocomplete-popper {
  margin-top: -1px;
}

.norstella-pf-MuiOutlinedInput-root {
  padding: 0px 9px;
}

/* Remove the default MUI border */
.norstella-pf-geo-autocomplete .norstella-pf-MuiOutlinedInput-notchedOutline,
.norstella-pf-plan-search-input .norstella-pf-MuiOutlinedInput-notchedOutline {
  border: none;
}

/* Style the dropdown options - CONSOLIDATED */
.norstella-pf-MuiAutocomplete-listbox {
  padding: 4px 0;
  min-height: auto;
  max-height: 250px;
  overflow-y: auto;
}

.norstella-pf-MuiAutocomplete-option {
  padding: 8px 16px;
  min-height: auto;
  transition: background-color 0.15s ease;
}

/* Style the dropdown paper/popper - CONSOLIDATED */
.norstella-pf-MuiAutocomplete-paper {
  margin: 0;
  margin-top: -1px;
  border-radius: 4px;
  min-height: auto;
  max-height: 250px;
  overflow: hidden;
}

.norstella-pf-MuiAutocomplete-popper {
  z-index: 1300;
}

/* Ensure focused state works correctly */
.norstella-pf-Mui-focused .norstella-pf-MuiOutlinedInput-notchedOutline {
  border: none;
}

/* ===== AUTOCOMPLETE OPTION STATES (CONSOLIDATED) ===== */

/* Selected option (when user has selected it previously) - highest priority */
.norstella-pf-MuiAutocomplete-option[aria-selected="true"],
.norstella-pf-MuiAutocomplete-option.Mui-selected {
  background-color: #e3f2fd;
  color: #000000;
  font-weight: 500;
}

/* Selected + Hover → Light gray (hover wins over selected) */
.norstella-pf-MuiAutocomplete-option[aria-selected="true"]:hover,
.norstella-pf-MuiAutocomplete-option.Mui-selected:hover {
  background-color: #dbd9d9;
  color: #000000;
  font-weight: 500;
}

/* Selected + Focused → Light gray (focus wins over selected) */
.norstella-pf-MuiAutocomplete-option[aria-selected="true"].Mui-focused,
.norstella-pf-MuiAutocomplete-option.Mui-selected.Mui-focused,
.norstella-pf-MuiAutocomplete-option[aria-selected="true"][data-focus="true"],
.norstella-pf-MuiAutocomplete-option.Mui-selected[data-focus="true"] {
  background-color: #dbd9d9;
  color: #000000;
  font-weight: 500;
}

/* Hovered option (mouse hover) */
.norstella-pf-MuiAutocomplete-option:hover {
  background-color: #dbd9d9;
  color: #000000;
  font-weight: 500;
}

/* Focused option (keyboard navigation) */
.norstella-pf-MuiAutocomplete-option.Mui-focused,
.norstella-pf-MuiAutocomplete-option[data-focus="true"] {
  background-color: #dbd9d9;
  color: #000000;
  font-weight: 500;
}

/* Additional states for better UX */
.norstella-pf-MuiAutocomplete-option.Mui-focused:hover {
  background-color: #dbd9d9;
  color: #000000;
  font-weight: 500;
}

/* Ensure proper contrast for accessibility */
.norstella-pf-MuiAutocomplete-option:focus {
  outline: 2px solid #1976d2;
  outline-offset: -2px;
}

/* ===== INPUT STYLING ===== */
.norstella-pf-geo-autocomplete .norstella-pf-MuiInputBase-input:focus,
.norstella-pf-plan-search-input .norstella-pf-MuiInputBase-input:focus {
  outline: none;
}
								 
.norstella-pf-geo-autocomplete .norstella-pf-MuiInputBase-root,
.norstella-pf-plan-search-input .norstella-pf-MuiInputBase-root {
  border: none;
  box-shadow: none;
  background: transparent;
}

.norstella-pf-geo-autocomplete .norstella-pf-MuiInputBase-input,
.norstella-pf-plan-search-input .norstella-pf-MuiInputBase-input {
  padding: 10px 6px;
}

.norstella-pf-MuiAutocomplete-endAdornment {
  right: 0;
}

.norstella-pf-MuiInputBase-root {
  padding-right: 0px;
}

/* ===== CLEAR ICON STYLING ===== */
.norstella-pf-autocomplete-custom-close {
  padding: 4px;
  margin: 0;
  color: #666;
}

.norstella-pf-autocomplete-custom-close:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.04);
}

.norstella-pf-autocomplete-custom-close svg {
  font-size: 18px;
  margin-right: 15px;
}


.norstella-pf-autocomplete-custom-close-location svg {
  font-size: 18px;
}

/* ===== END ADORNMENT POSITIONING ===== */
.norstella-pf-MuiInputAdornment-root {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.norstella-pf-MuiInputAdornment-endAdornment {
  margin-left: 0;
}


/* ===== MAIN CONTAINER CARDS (CONSOLIDATED) ===== */
.norstella-pf-maincontainer-leftCard {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.norstella-pf-maincontainer-rightCard {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.norstella-pf-maincontainer-topCard {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.norstella-pf-maincontainer-bottomCard {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
/* ===== CAROUSEL SECTION ===== */
.norstella-pf-carousel-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  height: inherit;
}

.norstella-pf-slide-strip {
  display: flex;
  width: 200%;
  height: inherit;
}

.norstella-pf-page-slide {
  width: 50%;
  flex-shrink: 0;
  height: inherit;
}

/* ===== POST SEARCH CONTENT ===== */
.norstella-pf-post-search-content {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* Card Result Name Section */
.norstella-pf-cardResultName-section {
  width: 100%;
  display: flex;
  justify-content: center;
}

.norstella-pf-cardResultName {
  font-size: 24px;
  font-weight: bold;
  color: #0a1f3d;
  text-align: center;
  margin: 0;
  padding: 0;
  line-height: 1.2;
}

/* Coverage Card Html Section */
.norstella-pf-coverageCardHtml-section {
  width: 100%;
  display: flex;
  justify-content: center;
}

.norstella-pf-coverageCardHtml {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  text-align: center;
  margin: 0;
  padding: 0;
  line-height: 1.4;
}

/* External Coverage Card Html Section */
.norstella-pf-externalCoverageCardHtml-section {
  display: flex;
  justify-content: center;
  width: 100%;
}

.norstella-pf-noResultMessage {
  color: #ff0000;
  font-weight: bold;
}

.norstella-pf-no-results-message {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: rgb(0, 0, 0);
}`, "",{"version":3,"sources":["webpack://./src/components/PatientFinder/DecisionTreeVS2/style.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,0CAA0C;EAC1C,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb;;;0BAGwB;EACxB,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,MAAM;EACN,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;;AAGA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb;;;;;;YAMU;EACV,gDAAgD;EAChD,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,MAAM;EACN,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,wEAAqW;EACrW,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,6DAA6D;AAC7D;EACE,YAAY;AACd;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;EACzB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,KAAK,qBAAqB,EAAE;EAC5B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,qBAAqB,EAAE;AAChC;;AAEA,iCAAiC;;AAEjC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,WAAW;AACb;;AAEA,gEAAgE;AAChE;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;;EAEE,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,mDAAmD;AACnD;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,YAAY;AACd;;AAEA,0DAA0D;;AAE1D,8EAA8E;AAC9E;;EAEE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;;EAEE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;;;;EAIE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;EAEE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;;EAEE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;AAGA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* NorstellaCoverageFinder styles */\r\n\r\n/* ===== BASE LAYOUT STYLES ===== */\r\n.norstella-pf-container {\r\n  display: flex;\r\n  font-family: Arial, sans-serif;\r\n  flex-direction: row;\r\n  height: inherit;\r\n}\r\n\r\n.norstella-pf-main-wrapper {\r\n  background-color: white;\r\n  border-radius: 10px; \r\n  padding: 5px;\r\n}\r\n\r\n.norstella-pf-channelCardPageContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: inherit;\r\n}\r\n\r\n/* ===== LEFT AND RIGHT PANELS ===== */\r\n.norstella-pf-right {\r\n  background-color: #d4dceb;\r\n  padding: 20px 40px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  order: 2;\r\n  flex-direction: column;\r\n  border-radius: 15px;\r\n}\r\n\r\n/* ===== HEADER STYLES ===== */\r\n.norstella-pf-header {\r\n  color: #0a1f3d;\r\n  font-weight: bold;\r\n  font-size: 28px;\r\n  white-space: initial;\r\n  margin-bottom: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.norstella-pf-nav-header {\r\n  color: #0a1f3d;\r\n  font-weight: bold;\r\n  font-size: 28px;\r\n  line-height: 1;\r\n  text-align: center;\r\n  margin: 0;\r\n  padding: 0;\r\n  white-space: nowrap;\r\n  text-decoration: underline;\r\n}\r\n\r\n.norstella-pf-headerSubHeader {\r\n  font-weight: bold;\r\n  white-space: initial;\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.norstella-pf-headerSubHeader span {\r\n  font-size: 14px;\r\n}\r\n\r\n/* ===== CHANNEL STYLES ===== */\r\n.norstella-pf-channels {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n  max-width: 600px;\r\n}\r\n\r\n.norstella-pf-channel {\r\n  background-color: #1e5c79;\r\n  color: white;\r\n  padding: 12px 16px;\r\n  text-align: center;\r\n  min-width: 160px;\r\n  border-radius: 10px;\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  box-shadow: 5px 4px 8px rgba(0, 0, 0, 0.4);\r\n  cursor: pointer;\r\n  transition: transform 0.2s;\r\n  min-width: 250px;\r\n}\r\n\r\n.norstella-pf-channel:hover {\r\n  transform: scale(1.03);\r\n  background-color: #1e5c79c2;\r\n}\r\n\r\n.norstella-pf-grid-wrapper {\r\n  display: flex;\r\n}\r\n\r\n.norstella-pf-grid-channel {\r\n  display: grid;\r\n  gap: 2.5rem 5rem;\r\n  max-width: 800px;\r\n}\r\n\r\n.norstella-pf-grid-channel .norstella-pf-channel:last-child {\r\n  grid-column: span 2;\r\n  justify-self: center;\r\n  width: 160px;\r\n  min-width: 160px;\r\n}\r\n\r\n.norstella-pf-footer {\r\n  font-size: 12px;\r\n  color: #333;\r\n  line-height: 1.5;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.norstella-pf-footer strong {\r\n  font-weight: bold;\r\n}\r\n\r\n/* ===== IFRAME STYLES ===== */\r\n.norstella-pf-iframe {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\r\n}\r\n\r\n.norstella-pf-externalhtml-container {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* ===== CHANNEL HTML CARD PAGE STYLES (CHCP) ===== */\r\n\r\n.norstella-pf-htmlCardPage-container {\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"nav-left nav-center nav-right\"\r\n    \"content content content\"\r\n    \"footer footer footer\";\r\n  grid-template-rows: auto 1fr auto;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  font-family: Arial, sans-serif;\r\n  background-color: #d4dceb;\r\n  padding: 15px 20px 0 20px;\r\n  gap: 0;\r\n  overflow: auto;\r\n  border-radius: 15px;\r\n  flex-grow: 1;\r\n}\r\n\r\n/* Grid Navigation Areas */\r\n.norstella-pf-nav-left {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.norstella-pf-nav-right {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* ===== NAVIGATION BUTTONS ===== */\r\n.norstella-pf-back-btn,\r\n.norstella-pf-forward-btn,\r\n.norstella-pf-changeSelectedResult-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 5px;\r\n  border: none;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-decoration: none;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n\r\n.norstella-pf-back-btn-icon,\r\n.norstella-pf-forward-btn-icon,\r\n.norstella-pf-changeSelectedResult-btn-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 16px;\r\n  line-height: 1;\r\n  width: 24px;\r\n  height: 24px;\r\n  overflow: hidden;\r\n}\r\n\r\n.norstella-pf-back-btn-label,\r\n.norstella-pf-forward-btn-label,\r\n.norstella-pf-changeSelectedResult-btn-label {\r\n  text-transform: capitalize;\r\n  font-weight: bold;\r\n  color: #000000;\r\n  text-decoration: underline;\r\n}\r\n\r\n\r\n/* ===== HEADER SECTION ===== */\r\n.norstella-pf-header-section {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* ===== CONTENT SECTION ===== */\r\n.norstella-pf-content-section {\r\n  grid-area: content;\r\n  overflow: hidden;\r\n  justify-self: center;\r\n  padding-top: 20px;\r\n}\r\n\r\n/* ===== FOOTER SECTION ===== */\r\n.norstella-pf-footer-section {\r\n  grid-area: footer;\r\n  padding: 20px 20px;\r\n}\r\n\r\n/* ===== CHANNEL SEARCH PAGE (CSP) ===== */\r\n.norstella-pf-channelSearchPage-main-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: inherit;\r\n}\r\n\r\n.norstella-pf-channelSearchPage-container {\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"nav\"\r\n    \"changeResult\"\r\n    \"search\"\r\n    \"plan\"\r\n    \"post\"\r\n    \"footer\";\r\n  grid-template-rows: auto auto auto auto 1fr auto;\r\n  grid-template-columns: 1fr;\r\n  font-family: Arial, sans-serif;\r\n  background-color: #d4dceb;\r\n  padding: 15px 20px 0 20px;\r\n  gap: 0;\r\n  overflow: auto;\r\n  border-radius: 15px;\r\n  flex-grow: 1;\r\n}\r\n\r\n/* ===== ROW WRAPPERS ===== */\r\n.norstella-pf-row { \r\n  width: 100%; \r\n}\r\n\r\n.norstella-pf-row-nav { \r\n  grid-area: nav; \r\n  display: grid; \r\n  grid-template-columns: 25% 50% 25%; \r\n  align-items: center;   \r\n}\r\n\r\n\r\n.norstella-pf-row-search { \r\n  grid-area: search;\r\n  display: grid;\r\n  grid-template-columns: 54% 46%;\r\n  margin-left: 10px;  \r\n}\r\n\r\n.norstella-pf-row-plan { \r\n  grid-area: plan; \r\n}\r\n\r\n.norstella-pf-row-post { \r\n  grid-area: post; \r\n}\r\n\r\n.norstella-pf-row-footer { \r\n  grid-area: footer; \r\n}\r\n\r\n/* ===== SEARCH COMPONENTS ===== */\r\n.norstella-pf-search-row {\r\n  grid-area: search;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 0 0 6px 0;\r\n  margin-top: 12px;\r\n}\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   \r\n.norstella-pf-subheader-wrap {\r\n  grid-area: subheader;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n\t\t\t\t\t\t\t\t   \r\n.norstella-pf-location-controls { \r\n  display: block;\r\n  position: relative;\r\n}\r\n\r\n.norstella-pf-search-label,\r\n.norstella-pf-plan-label { \r\n  font-family: Arial, sans-serif;\r\n  font-size: 13px; \r\n  display: block;\r\n  color: #22346A;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.norstella-pf-location-input-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.norstella-pf-input-group {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: #ffffff;\r\n  border-radius: 7px;\r\n  border: 1px solid #666;\r\n  height: 38px;\r\n  position: relative;\r\n}\r\n\r\n/* Error state styling for input group */\r\n.norstella-pf-input-group.norstella-pf-error-state {\r\n  border: 2px solid red;\r\n  box-shadow: 0 0 0 1px red;\r\n}\r\n\r\n.norstella-pf-input-with-icon { \r\n  position: relative; \r\n}\r\n\r\n.norstella-pf-input-with-icon .norstella-pf-input { \r\n  padding-left: 28px; \r\n}\r\n\r\n.norstella-pf-input-icon {\r\n  position: absolute;\r\n  left: 8px;\r\n  width: 16px;\r\n  height: 16px;\r\n  mask: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"%235b6b86\"><path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"/></svg>') no-repeat center / contain;\r\n  background-color: #5b6b86;\r\n}\r\n\r\n.norstella-pf-input {\r\n  border: none;\r\n  outline: none;\r\n  font-size: 14px;\r\n  width: 250px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.norstella-pf-clear-btn {\r\n  border: none;\r\n  background: transparent;\r\n  color: #5b6b86;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  padding: 0 4px;\r\n}\r\n\r\n.norstella-pf-primary-btn {\r\n  background: #0a1f3d;\r\n  color: #ffffff;\r\n  border-radius: 7px;\r\n  font-weight: 700;\r\n  cursor: pointer;  \r\n  margin-top: 16px;\r\n  width: 100px;\r\n  font-size: 16px;\r\n  height: 38px;\r\n}\r\n\r\n.norstella-pf-primary-btn:disabled { \r\n  opacity: 0.5;\r\n  cursor: unset;\r\n}\r\n\r\n/* ===== ERROR MESSAGE ===== */\r\n.norstella-pf-error-message { \r\n  color: red;\r\n  font-size: 13px;\r\n  font-weight: bold;\r\n  margin-top: 4px;\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.norstella-pf-no-plan-details {\r\n  color: red;\r\n}\r\n\r\n/* ===== PLAN SEARCH ===== */\r\n.norstella-pf-plan-search-row {\r\n  grid-area: plan;\r\n  width: 100%;\r\n  margin-left: 10px;\r\n}\r\n\r\n.norstella-pf-plan-input-group { \r\n  width: 100%; \r\n  height: 38px;   \r\n  margin-bottom: 20px;\r\n}\r\n\r\n\r\n/* ===== DISABLED AND HIGHLIGHT Location & Plan input ===== */\r\n.norstella-pf-disabled {\r\n  opacity: 0.6;\r\n}\r\n\r\n/* Highlight for plan search only (not for geo location input) */\r\n.norstella-pf-highlight-search {\r\n  border: 1px solid #000000;\r\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);\r\n  animation: pulse-border 1s ease-in-out;\r\n}\r\n\r\n@keyframes pulse-border {\r\n  0% { border-color: #000000; }\r\n  50% { border-color: #333333; }\r\n  100% { border-color: #000000; }\r\n}\r\n\r\n/* ===== SUBHEADER STYLES ===== */\r\n\t\t\t\t\t\t\t\t\t\t\t\t \r\n.norstella-pf-subheader, .norstella-pf-nav-subheader { \r\n  white-space: normal; \r\n  text-overflow: unset; \r\n  overflow: hidden; \r\n  color: rgb(10, 31, 61);\r\n}\r\n\r\n.norstella-pf-geo {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-right: 10px;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n}\r\n\r\n/* Geo Location Container for Post Search */\r\n.norstella-pf-geo-post-search {\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 0px;\r\n}\r\n\r\n/* Change Selected Result Button */\r\n.norstella-pf-nav-changeSelectedResult {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Change Selected Result Button - Top Position (when hideLocation is true) */\r\n.norstella-pf-nav-changeSelectedResult-top {\r\n  display: flex;\r\n  justify-content: flex-end; \r\n  grid-area: changeResult; \r\n}\r\n\r\n/* ===== MUI AUTOCOMPLETE STYLES (CONSOLIDATED) ===== */\r\n.norstella-pf-MuiAutocomplete-root {\r\n  width: 100%;\r\n}\r\n\r\n/* Ensure autocomplete dropdown connects seamlessly with input */\r\n.norstella-pf-geo-autocomplete,\r\n.norstella-pf-plan-search-input {\r\n  position: relative;\r\n}\r\n\r\n.norstella-pf-geo-autocomplete .norstella-pf-MuiAutocomplete-popper,\r\n.norstella-pf-plan-search-input .norstella-pf-MuiAutocomplete-popper {\r\n  margin-top: -1px;\r\n}\r\n\r\n.norstella-pf-MuiOutlinedInput-root {\r\n  padding: 0px 9px;\r\n}\r\n\r\n/* Remove the default MUI border */\r\n.norstella-pf-geo-autocomplete .norstella-pf-MuiOutlinedInput-notchedOutline,\r\n.norstella-pf-plan-search-input .norstella-pf-MuiOutlinedInput-notchedOutline {\r\n  border: none;\r\n}\r\n\r\n/* Style the dropdown options - CONSOLIDATED */\r\n.norstella-pf-MuiAutocomplete-listbox {\r\n  padding: 4px 0;\r\n  min-height: auto;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.norstella-pf-MuiAutocomplete-option {\r\n  padding: 8px 16px;\r\n  min-height: auto;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n/* Style the dropdown paper/popper - CONSOLIDATED */\r\n.norstella-pf-MuiAutocomplete-paper {\r\n  margin: 0;\r\n  margin-top: -1px;\r\n  border-radius: 4px;\r\n  min-height: auto;\r\n  max-height: 250px;\r\n  overflow: hidden;\r\n}\r\n\r\n.norstella-pf-MuiAutocomplete-popper {\r\n  z-index: 1300;\r\n}\r\n\r\n/* Ensure focused state works correctly */\r\n.norstella-pf-Mui-focused .norstella-pf-MuiOutlinedInput-notchedOutline {\r\n  border: none;\r\n}\r\n\r\n/* ===== AUTOCOMPLETE OPTION STATES (CONSOLIDATED) ===== */\r\n\r\n/* Selected option (when user has selected it previously) - highest priority */\r\n.norstella-pf-MuiAutocomplete-option[aria-selected=\"true\"],\r\n.norstella-pf-MuiAutocomplete-option.Mui-selected {\r\n  background-color: #e3f2fd;\r\n  color: #000000;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Selected + Hover → Light gray (hover wins over selected) */\r\n.norstella-pf-MuiAutocomplete-option[aria-selected=\"true\"]:hover,\r\n.norstella-pf-MuiAutocomplete-option.Mui-selected:hover {\r\n  background-color: #dbd9d9;\r\n  color: #000000;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Selected + Focused → Light gray (focus wins over selected) */\r\n.norstella-pf-MuiAutocomplete-option[aria-selected=\"true\"].Mui-focused,\r\n.norstella-pf-MuiAutocomplete-option.Mui-selected.Mui-focused,\r\n.norstella-pf-MuiAutocomplete-option[aria-selected=\"true\"][data-focus=\"true\"],\r\n.norstella-pf-MuiAutocomplete-option.Mui-selected[data-focus=\"true\"] {\r\n  background-color: #dbd9d9;\r\n  color: #000000;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Hovered option (mouse hover) */\r\n.norstella-pf-MuiAutocomplete-option:hover {\r\n  background-color: #dbd9d9;\r\n  color: #000000;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Focused option (keyboard navigation) */\r\n.norstella-pf-MuiAutocomplete-option.Mui-focused,\r\n.norstella-pf-MuiAutocomplete-option[data-focus=\"true\"] {\r\n  background-color: #dbd9d9;\r\n  color: #000000;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Additional states for better UX */\r\n.norstella-pf-MuiAutocomplete-option.Mui-focused:hover {\r\n  background-color: #dbd9d9;\r\n  color: #000000;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Ensure proper contrast for accessibility */\r\n.norstella-pf-MuiAutocomplete-option:focus {\r\n  outline: 2px solid #1976d2;\r\n  outline-offset: -2px;\r\n}\r\n\r\n/* ===== INPUT STYLING ===== */\r\n.norstella-pf-geo-autocomplete .norstella-pf-MuiInputBase-input:focus,\r\n.norstella-pf-plan-search-input .norstella-pf-MuiInputBase-input:focus {\r\n  outline: none;\r\n}\r\n\t\t\t\t\t\t\t\t \r\n.norstella-pf-geo-autocomplete .norstella-pf-MuiInputBase-root,\r\n.norstella-pf-plan-search-input .norstella-pf-MuiInputBase-root {\r\n  border: none;\r\n  box-shadow: none;\r\n  background: transparent;\r\n}\r\n\r\n.norstella-pf-geo-autocomplete .norstella-pf-MuiInputBase-input,\r\n.norstella-pf-plan-search-input .norstella-pf-MuiInputBase-input {\r\n  padding: 10px 6px;\r\n}\r\n\r\n.norstella-pf-MuiAutocomplete-endAdornment {\r\n  right: 0;\r\n}\r\n\r\n.norstella-pf-MuiInputBase-root {\r\n  padding-right: 0px;\r\n}\r\n\r\n/* ===== CLEAR ICON STYLING ===== */\r\n.norstella-pf-autocomplete-custom-close {\r\n  padding: 4px;\r\n  margin: 0;\r\n  color: #666;\r\n}\r\n\r\n.norstella-pf-autocomplete-custom-close:hover {\r\n  color: #333;\r\n  background-color: rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.norstella-pf-autocomplete-custom-close svg {\r\n  font-size: 18px;\r\n  margin-right: 15px;\r\n}\r\n\r\n\r\n.norstella-pf-autocomplete-custom-close-location svg {\r\n  font-size: 18px;\r\n}\r\n\r\n/* ===== END ADORNMENT POSITIONING ===== */\r\n.norstella-pf-MuiInputAdornment-root {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.norstella-pf-MuiInputAdornment-endAdornment {\r\n  margin-left: 0;\r\n}\r\n\r\n\r\n/* ===== MAIN CONTAINER CARDS (CONSOLIDATED) ===== */\r\n.norstella-pf-maincontainer-leftCard {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.norstella-pf-maincontainer-rightCard {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.norstella-pf-maincontainer-topCard {\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n\r\n.norstella-pf-maincontainer-bottomCard {\r\n  border-bottom-left-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n/* ===== CAROUSEL SECTION ===== */\r\n.norstella-pf-carousel-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  height: inherit;\r\n}\r\n\r\n.norstella-pf-slide-strip {\r\n  display: flex;\r\n  width: 200%;\r\n  height: inherit;\r\n}\r\n\r\n.norstella-pf-page-slide {\r\n  width: 50%;\r\n  flex-shrink: 0;\r\n  height: inherit;\r\n}\r\n\r\n/* ===== POST SEARCH CONTENT ===== */\r\n.norstella-pf-post-search-content {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: #000000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n/* Card Result Name Section */\r\n.norstella-pf-cardResultName-section {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.norstella-pf-cardResultName {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  color: #0a1f3d;\r\n  text-align: center;\r\n  margin: 0;\r\n  padding: 0;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Coverage Card Html Section */\r\n.norstella-pf-coverageCardHtml-section {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.norstella-pf-coverageCardHtml {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: #000000;\r\n  text-align: center;\r\n  margin: 0;\r\n  padding: 0;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* External Coverage Card Html Section */\r\n.norstella-pf-externalCoverageCardHtml-section {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.norstella-pf-noResultMessage {\r\n  color: #ff0000;\r\n  font-weight: bold;\r\n}\r\n\r\n.norstella-pf-no-results-message {\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: rgb(0, 0, 0);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
